// @flow
export { default } from './InputBadges';



// WEBPACK FOOTER //
// ./src/components/write/InputBadges/index.js